import { defineStore } from "pinia";

export const useSchoolStore = defineStore('school', {
    state: () => ({
        school: {},
        schools: [],
    }),
    actions: {
        setSchool(school) {
            this.school = school
        },
        setSchools(schools) {
            this.schools = schools
        },
        addSchool(school) {
            this.schools.unshift(school)
        },
        updateSchool(school) {
            let index = this.schools.findIndex(cl => cl.id === school.id)
            this.schools.splice(index, 1, school)
        },
        deleteSchool(school) {
            let index = this.schools.findIndex(cl => cl.id === school.id)
            this.schools.splice(index, 1)
        },
    },
});